import { validateTitle, validateGoal, validateEndDate, validateStartDate } from '../validations/sprints';

export const getEmptyInputsErrorsObject = (inputsObject) => {
	let errorsObject = {};
	Object.keys(inputsObject).forEach((key) => {
		const value = inputsObject[key];
		if (!value) {
			if (key === 'Title') {
				const { error } = validateTitle({ value });
				errorsObject = { ...errorsObject, Title: error };
			} else if (key === 'Description') {
				const { error } = validateGoal({ value });
				errorsObject = { ...errorsObject, Goal: error };
			} else if (key === 'EndDate') {
				const { error } = validateEndDate({ value });
				errorsObject = { ...errorsObject, EndDate: error };
			} else if (key === 'StartDate') {
				const { error } = validateStartDate({ value });
				errorsObject = { ...errorsObject, StartDate: error };
			}
		}
	});
	return errorsObject;
};
